import type { Carousel, CarouselFilter as CarouselFilterTrackingData, Recommender } from '@coursera/event-pulse-types';

/**
 * Carousel payload for `click_button` with `button.name: collections_filter_chip`.
 *
 * `name` is the parent carousel / section headline (outer recommender). The chip label belongs on
 * `filter.name` via `filter` — not on `name`.
 */
export function buildCarouselForFilter({
  id,
  name,
  recommender,
  filter,
}: {
  id: string;
  /** Parent complex-collection / module headline. Omit when unknown — never substitute the chip label. */
  name?: string;
  recommender?: Recommender;
  filter?: CarouselFilterTrackingData;
}): Carousel {
  return {
    id,
    ...(name !== undefined && name.length > 0 ? { name } : {}),
    ...(recommender ? { recommender } : {}),
    ...(filter ? { filter } : {}),
  };
}
